// components/MemberPortal/ScheduleRoundModal.js
import React, { useState } from 'react';
import axiosInstance from '../../axiosConfig';

const ScheduleRoundModal = ({ playRequest, onClose, onScheduled }) => {
  const [formData, setFormData] = useState({
    scheduled_date: playRequest?.preferred_date || '',
    scheduled_time: '09:00',
    notes: ''
  });
  const [submitting, setSubmitting] = useState(false);

  // Get tomorrow's date as minimum
  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const minDate = tomorrow.toISOString().split('T')[0];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      await axiosInstance.post(
        `/member-portal/play-requests/${playRequest.request_id}/schedule/`,
        formData
      );
      onScheduled();
    } catch (error) {
      console.error('Error scheduling round:', error);
      alert('Error scheduling round. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="modal-overlay">
      <div className="schedule-modal">
        <div className="modal-header">
          <h3>Schedule Round</h3>
          <button className="close-button" onClick={onClose}>✕</button>
        </div>

        <div className="modal-body">
          <div className="request-info">
            <h4>{playRequest?.target_club?.name}</h4>
            <p>
              Guest: {playRequest?.requester?.user?.first_name ||
                      playRequest?.requester?.user?.username || 'Member'}
            </p>
            {playRequest?.requester?.handicap && (
              <p>Handicap: {playRequest.requester.handicap}</p>
            )}
          </div>

          <form onSubmit={handleSubmit} className="schedule-form">
            <div className="form-group">
              <label htmlFor="scheduled_date">Date:</label>
              <input
                type="date"
                id="scheduled_date"
                value={formData.scheduled_date}
                onChange={(e) => handleInputChange('scheduled_date', e.target.value)}
                min={minDate}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="scheduled_time">Tee Time:</label>
              <select
                id="scheduled_time"
                value={formData.scheduled_time}
                onChange={(e) => handleInputChange('scheduled_time', e.target.value)}
                required
              >
                <option value="07:00">7:00 AM</option>
                <option value="07:30">7:30 AM</option>
                <option value="08:00">8:00 AM</option>
                <option value="08:30">8:30 AM</option>
                <option value="09:00">9:00 AM</option>
                <option value="09:30">9:30 AM</option>
                <option value="10:00">10:00 AM</option>
                <option value="10:30">10:30 AM</option>
                <option value="11:00">11:00 AM</option>
                <option value="11:30">11:30 AM</option>
                <option value="12:00">12:00 PM</option>
                <option value="12:30">12:30 PM</option>
                <option value="13:00">1:00 PM</option>
                <option value="13:30">1:30 PM</option>
                <option value="14:00">2:00 PM</option>
                <option value="14:30">2:30 PM</option>
                <option value="15:00">3:00 PM</option>
                <option value="15:30">3:30 PM</option>
                <option value="16:00">4:00 PM</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="notes">Additional Notes (optional):</label>
              <textarea
                id="notes"
                value={formData.notes}
                onChange={(e) => handleInputChange('notes', e.target.value)}
                placeholder="Meeting location, dress code, special instructions..."
                rows={3}
              />
            </div>

            <div className="modal-actions">
              <button type="button" onClick={onClose} disabled={submitting}>
                Cancel
              </button>
              <button
                type="submit"
                className="schedule-button"
                disabled={!formData.scheduled_date || !formData.scheduled_time || submitting}
              >
                {submitting ? 'Scheduling...' : 'Schedule Round'}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ScheduleRoundModal;

// CSS styles for the new components (add to your existing CSS)
/*
.chat-window-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.chat-window {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 600px;
  height: 80vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.chat-header {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-title h3 {
  margin: 0;
  color: #1f2937;
}

.chat-title p {
  margin: 5px 0 0 0;
  color: #6b7280;
  font-size: 14px;
}

.close-button {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6b7280;
  padding: 5px;
}

.close-button:hover {
  color: #374151;
}

.action-banner {
  background: #f3f4f6;
  border-bottom: 1px solid #e5e7eb;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.banner-message {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 500;
  color: #374151;
}

.banner-icon {
  font-size: 18px;
}

.banner-actions {
  display: flex;
  gap: 12px;
}

.schedule-button, .confirm-button {
  background: #10b981;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.schedule-button:hover, .confirm-button:hover {
  background: #059669;
}

.deny-button, .cancel-button {
  background: #ef4444;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.deny-button:hover, .cancel-button:hover {
  background: #dc2626;
}

.request-summary {
  padding: 16px 20px;
  background: #f9fafb;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  gap: 20px;
  flex-wrap: wrap;
}

.summary-item {
  display: flex;
  gap: 8px;
  align-items: center;
}

.status {
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
}

.status.pending { background: #fef3c7; color: #92400e; }
.status.scheduled { background: #dbeafe; color: #1e40af; }
.status.confirmed { background: #d1fae5; color: #065f46; }
.status.declined { background: #fee2e2; color: #991b1b; }
.status.completed { background: #e0e7ff; color: #3730a3; }

.messages-container {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.loading-messages, .no-messages {
  text-align: center;
  color: #6b7280;
  margin-top: 40px;
}

.messages-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.message {
  display: flex;
}

.message.from-me {
  justify-content: flex-end;
}

.message.from-other {
  justify-content: flex-start;
}

.message-content {
  max-width: 70%;
  padding: 12px 16px;
  border-radius: 12px;
  position: relative;
}

.message.from-me .message-content {
  background: #3b82f6;
  color: white;
  border-bottom-right-radius: 4px;
}

.message.from-other .message-content {
  background: #f3f4f6;
  color: #374151;
  border-bottom-left-radius: 4px;
}

.message-time {
  font-size: 11px;
  opacity: 0.7;
  display: block;
  margin-top: 4px;
}

.message-input-form {
  padding: 20px;
  border-top: 1px solid #e5e7eb;
}

.input-container {
  display: flex;
  gap: 12px;
}

.message-input {
  flex: 1;
  padding: 12px 16px;
  border: 1px solid #d1d5db;
  border-radius: 24px;
  outline: none;
}

.message-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.send-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 24px;
  cursor: pointer;
  font-weight: 500;
}

.send-button:hover:not(:disabled) {
  background: #2563eb;
}

.send-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
}

.schedule-modal {
  background: white;
  border-radius: 12px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

.modal-header {
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  color: #1f2937;
}

.modal-body {
  padding: 20px;
}

.request-info {
  background: #f9fafb;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.request-info h4 {
  margin: 0 0 8px 0;
  color: #1f2937;
}

.request-info p {
  margin: 4px 0;
  color: #6b7280;
}

.schedule-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.form-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.form-group label {
  font-weight: 500;
  color: #374151;
}

.form-group input, .form-group select, .form-group textarea {
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  outline: none;
}

.form-group input:focus, .form-group select:focus, .form-group textarea:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 24px;
}

.modal-actions button {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}

.modal-actions button[type="button"] {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.modal-actions button[type="button"]:hover {
  background: #e5e7eb;
}

.sub-tabs {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.sub-tab {
  padding: 8px 16px;
  border: 1px solid #e5e7eb;
  background: white;
  color: #6b7280;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.sub-tab.active {
  background: #3b82f6;
  color: white;
  border-color: #3b82f6;
}

.sub-tab:hover:not(.active) {
  background: #f9fafb;
}

.view-message-button, .view-chat-button {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.view-message-button:hover, .view-chat-button:hover {
  background: #2563eb;
}

.member-card {
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: 600px;
  margin: 0 auto;
}

.card-header {
  background: linear-gradient(135deg, #3b82f6, #1e40af);
  color: white;
  padding: 30px 20px;
  display: flex;
  align-items: center;
  gap: 20px;
}

.member-avatar {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: bold;
}

.member-details h2 {
  margin: 0;
  font-size: 24px;
}

.member-since {
  margin: 4px 0 0 0;
  opacity: 0.9;
}

.verification-badge {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.2);
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 14px;
}

.card-body {
  padding: 30px 20px;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.info-item .label {
  font-size: 12px;
  text-transform: uppercase;
  color: #6b7280;
  font-weight: 600;
}

.info-item .value {
  font-size: 16px;
  color: #1f2937;
  font-weight: 500;
}

.bio-section, .preferences-section {
  margin-top: 30px;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
}

.bio-section h4, .preferences-section h4 {
  margin: 0 0 12px 0;
  color: #1f2937;
}

.bio-section p {
  color: #6b7280;
  line-height: 1.6;
}

.preferences-section p {
  margin: 8px 0;
  color: #6b7280;
}

.rating-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
}

.rating-modal .modal-content {
  background: white;
  border-radius: 12px;
  padding: 24px;
  width: 90%;
  max-width: 400px;
}

.rating-modal h3 {
  margin: 0 0 20px 0;
  color: #1f2937;
}

.rating-input, .feedback-input {
  margin-bottom: 16px;
}

.rating-input label, .feedback-input label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #374151;
}

.rating-input select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
}

.feedback-input textarea {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  resize: vertical;
}

.modal-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.modal-actions button {
  padding: 10px 20px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}

.modal-actions button:first-child {
  background: #f3f4f6;
  color: #374151;
  border: 1px solid #d1d5db;
}

.modal-actions button:last-child {
  background: #3b82f6;
  color: white;
  border: none;
}

.modal-actions button:hover:first-child {
  background: #e5e7eb;
}

.modal-actions button:hover:last-child {
  background: #2563eb;
}

.experiences-list, .requests-list {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.experience-card, .request-card {
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.experience-info, .request-info {
  flex: 1;
}

.experience-info h4, .request-info h4 {
  margin: 0 0 8px 0;
  color: #1f2937;
}

.experience-info p, .request-info p {
  margin: 4px 0;
  color: #6b7280;
}

.request-message {
  font-style: italic;
  margin-top: 12px;
  padding: 12px;
  background: #f9fafb;
  border-radius: 6px;
}

.requester-details {
  margin-top: 12px;
  padding: 12px;
  background: #f0f9ff;
  border-radius: 6px;
  border-left: 4px solid #3b82f6;
}

.ratings-display {
  margin-top: 12px;
  padding: 12px;
  background: #f0fdf4;
  border-radius: 6px;
}

.feedback {
  font-style: italic;
  margin-top: 8px;
}

.request-actions, .experience-actions {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.rate-button {
  background: #f59e0b;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
}

.rate-button:hover {
  background: #d97706;
}
*/